import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import RFRLink from 'redux-first-router-link';
import { direction } from '../../../actions/gallery/index';
import { buttonBarStyles, IconWrapper, ButtonBarVariant } from './ButtonBar';

export interface ButtonLinkProps {
  to: string | object;
  pageDirection?: string;
  variant?: ButtonBarVariant;
  icon?: ReactNode | string;
  fullWidth?: boolean;
  compact?: boolean;
  onClick?: () => void;
  id?: string;
  className?: string;
  ariaLabel?: string;
  children?: ReactNode;
}

const CleanRFRLink = ({ $variant, $fullWidth, $compact, ...props }: any) => <RFRLink {...props} />;

const StyledLink = styled(CleanRFRLink)<{
  $variant: ButtonBarVariant;
  $fullWidth?: boolean;
  $compact?: boolean;
}>`
  ${buttonBarStyles}
  text-decoration: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
`;

export const ButtonLink: FC<ButtonLinkProps> = ({
  to,
  pageDirection,
  variant = 'filled',
  icon,
  fullWidth,
  compact,
  onClick,
  children,
  id,
  className,
  ariaLabel,
}) => {
  const dispatch = useDispatch();

  const handleClick = () => {
    if (pageDirection) {
      dispatch(direction(pageDirection));
    }
    if (onClick) {
      onClick();
    }
  };

  return (
    <StyledLink
      to={to}
      id={id}
      aria-label={ariaLabel}
      className={className}
      onClick={handleClick}
      $variant={variant}
      $fullWidth={fullWidth}
      $compact={compact}
    >
      {icon && (
        <IconWrapper>
          {typeof icon === 'string' ? <img src={icon} alt="" /> : icon}
        </IconWrapper>
      )}
      <span>{children}</span>
    </StyledLink>
  );
};

export default ButtonLink;
